import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TornMesh, MeshRoll } from "@/components/ui/icons/A1Icons";
import Reveal from "@/components/ui/Reveal";

const SIDES = [
    {
        icon: TornMesh,
        title: "A repair is usually enough when…",
        points: [
            "One or two panels are torn or loose",
            "The frame is straight and solid",
            "The rest of the mesh still has life in it",
        ],
        to: "/services/pool-cage-repair",
        cta: "View Pool Cage Repair",
        testId: "rr-repair-link",
    },
    {
        icon: MeshRoll,
        title: "A full rescreen usually makes sense when…",
        points: [
            "Several panels are torn or sagging",
            "Mesh is sun-faded or brittle to the touch",
            "No-see-ums are getting through everywhere",
        ],
        to: "/services/pool-rescreening",
        cta: "View Pool Rescreening",
        testId: "rr-rescreen-link",
    },
];

export default function RepairOrRescreenCard() {
    return (
        <section className="a1-section" data-testid="repair-or-rescreen-card">
            <div className="a1-container max-w-5xl">
                <Reveal>
                    <div className="max-w-3xl mb-10">
                        <p className="a1-eyebrow mb-3">Repair or Rescreen?</p>
                        <h2 className="mb-3 a1-h2-underline">Not Sure Which One You Need?</h2>
                        <p className="text-lg leading-relaxed" style={{ color: "var(--color-text-muted)" }}>
                            Here's the honest rule of thumb we use on every Naples cage we look at.
                        </p>
                    </div>
                </Reveal>
                <div className="relative grid md:grid-cols-2 gap-5">
                    <span className="rr-or-badge" aria-hidden="true">OR</span>
                    {SIDES.map((side, idx) => {
                        const Icon = side.icon;
                        return (
                            <Reveal key={side.to} delay={idx * 100}>
                                <div className="a1-card a1-card-feature flex flex-col gap-4 h-full">
                                    <div className="a1-icon-wrap-lg">
                                        <Icon size={26} strokeWidth={1.8} />
                                    </div>
                                    <h3 className="text-xl leading-snug">{side.title}</h3>
                                    <ul className="m-0 p-0 list-none space-y-2 flex-1">
                                        {side.points.map((p) => (
                                            <li key={p} className="flex items-start gap-2 text-[15px] leading-relaxed" style={{ color: "var(--color-text-muted)" }}>
                                                <span aria-hidden="true" style={{ color: "var(--color-accent)", fontWeight: 800 }}>—</span>
                                                {p}
                                            </li>
                                        ))}
                                    </ul>
                                    <Link to={side.to} className="a1-btn-secondary self-start" data-testid={side.testId}>
                                        {side.cta} <ArrowRight size={15} />
                                    </Link>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
                <p className="a1-helper mt-7">
                    Every cage is different. Send photos or call 239-434-7306 — final recommendations and pricing are confirmed after technician review.
                </p>
            </div>
        </section>
    );
}
